import { render, staticRenderFns } from "./RightTeam.vue?vue&type=template&id=16ebfb83&"
import script from "./RightTeam.vue?vue&type=script&lang=js&"
export * from "./RightTeam.vue?vue&type=script&lang=js&"
import style0 from "./RightTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QInput,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QInput,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn})
